require('../../modules/es6.object.keys');
module.exports = require('../../modules/_core').Object.keys;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/fn/object/keys.js
// module id = 597
// module chunks = 168707334958949